import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'

import './css/styles.scss'

import OrderClass from './../../../../../../../js/classes/Order.js'
import ScrollClass from './../../../../../../../js/classes/Scroll.js'

import CartSmallApp from './../../../../cart.small/templates/.default/react/component.jsx'

import DataContext from './contexts/data.jsx'

import Loading from './Loading.jsx'

import ContactsStep from './steps/contacts/Contacts.jsx'
import DeliveryStep from './steps/delivery/Delivery.jsx'
import PaymentsStep from './steps/payments/Payments.jsx'
import Footer from './Footer.jsx'

const OrderApp = () => {
    const defaultValue = useContext(DataContext),
    [data, setData] = useState(defaultValue),
    [isLoading, setLoading] = useState(true),
    [, forceRender] = useState(0)

    const sanitizeRestrictions = (_restrictions) => {
        const restrictions = {
            DELIVERY : _restrictions.DELIVERY.reduce((r, restriction) => {
                r[restriction.ID] = restriction

                return r
            }, {}),

            PAYMENTS : _restrictions.PAYMENTS.reduce((r, restriction) => {
                r[restriction.ID] = restriction

                return r
            }, {}),
        }

        return restrictions
    },
    sanitizeDataID = (sanitizeData) => {
        return sanitizeData.reduce((r, sanitizeItem) => {
            r[sanitizeItem.ID] = sanitizeItem

            return r
        }, {})
    }
    
    const refetch = (cb) => {
        OrderClass.getData((err, res) => {
            if (err) {
                
            } else {
                const newContextData = Object.assign({}, data)

                if (!newContextData.contacts) {
                    const fields = res.properties.reduce((r, propertyGroup) => {
                        r[propertyGroup.ID] = (propertyGroup.PROPERTIES || []).reduce((r2, property) => {
                            r2[property.CODE] = property

                            return r2
                        }, {})

                        return r
                    }, {})

                    //Contacts
                    newContextData.contacts = {
                        person : res.persons[0].ID,
                        fields
                    }

                    //Delivery
                    newContextData.delivery = {
                        id : null,
                    }

                    //Payments
                    newContextData.payments = {
                        id : null,
                    }

                    //Comment
                    newContextData.comment = ''
                }

                newContextData.data = res
                newContextData.data._restrictions = newContextData.data.restrictions
                newContextData.data.restrictions = sanitizeRestrictions(newContextData.data.restrictions)

                newContextData.data._delivery = sanitizeDataID(newContextData.data.delivery)
                newContextData.data._payments = sanitizeDataID(newContextData.data.payments)
                newContextData.data._persons = sanitizeDataID(newContextData.data.persons)
                newContextData.data._stores = sanitizeDataID(newContextData.data.stores)
                newContextData.data._properties = sanitizeDataID(newContextData.data.properties)
                newContextData.data._propertiesList = sanitizeDataID(newContextData.data.propertiesList)

                if (Array.isArray(res.delivery_pick_points)) {
                    newContextData.delivery_pick_points = res.delivery_pick_points.reduce((r, pick_point_str) => {
                        const pick_point_split = pick_point_str.split(':')

                        const pick_point = {
                            TYPE : pick_point_split[0],
                            DELIVERY_ID : +pick_point_split[1],
                            PROPERTY_CODE : pick_point_split[2],
                            VALUE : null
                        }

                        r[pick_point.DELIVERY_ID] = pick_point

                        return r
                    }, {})
                } else {
                    newContextData.delivery_pick_points = {}
                }

                setData(newContextData)
            }

            if (cb) cb(err, res)
        })
    }

    //Отправка заказа
    const checkFieldsErrors = () => {
        const contactsProperties = []
        
        data.data.properties.forEach((propertyGroup) => {
            if (propertyGroup.ID == 1 || propertyGroup.ID == 3) {
                if (propertyGroup.PERSON_TYPE_ID == data.contacts.person) {
                    propertyGroup.PROPERTIES.forEach((property) => {
                        contactsProperties.push(property)
                    })
                }
            }
        })

        let isContactsErrors = false

        contactsProperties.forEach((property) => {
            const value = property.value || ''

            try {
                if (property.REQUIRED === false && value === '') {
                    
                } else {
                    const regExp = property.SETTINGS.PATTERN ? new RegExp(property.SETTINGS.PATTERN) : null
                    
                    if (regExp) {
                        if (isContactsErrors === false) {
                            isContactsErrors = !regExp.test(value)
                        }
                    }
                }
            } catch(e) {
                
            }
        })

        if (isContactsErrors) {
            ScrollClass.scrollTo('.happy-order__step_contacts')

            return false
        }
        
        //Delivery
        //Временное решение!
        const deliveryProperties = {}

        data.data.properties.forEach((propertyGroup) => {
            if (propertyGroup.ID == 2 || propertyGroup.ID == 4) {
                if (propertyGroup.PERSON_TYPE_ID == data.contacts.person) {
                    propertyGroup.PROPERTIES.forEach((property) => {
                        deliveryProperties[property.CODE] = property
                    })
                }
            }
        })

        let isDeliveryErrors = false

        document.querySelectorAll('.happy-order__delivery-fields .happy-order__delivery-property').forEach((propertyContainer) => {
            const property = deliveryProperties[propertyContainer.getAttribute('data-code')]

            if (property) {
                const value = property.value || ''
                
                try {
                    if (property.REQUIRED === false && value === '') {
                        
                    } else {
                        const regExp = property.SETTINGS.PATTERN ? new RegExp(property.SETTINGS.PATTERN) : null
                        
                        if (regExp) {
                            if (isDeliveryErrors === false) {
                                isDeliveryErrors = !regExp.test(value)
                            }
                        }
                    }
                } catch(e) {
                    
                }
            }
        })

        if (isDeliveryErrors) {
            ScrollClass.scrollTo('.happy-order__delivery-fields')

            return false
        }

        return true
    },
    handleSendOrder = (e) => {
        const currentDelivery = data.data._delivery[data.delivery.id],
        sendData = {
            contacts : data.contacts,
            delivery : data.delivery,
            payments : data.payments,
            comment : data.comment,
            current_location : data.data.current_location,
            pick_points : data.delivery_pick_points,
        },
        sendButtonNode = e.target,
        sendButtonText = sendButtonNode.textContent

        if (currentDelivery) {
            sendData.delivery.PRICE = Math.round(currentDelivery.PRICE) || 0
            sendData.delivery.PERIOD = currentDelivery.PERIOD
        }

        if (!checkFieldsErrors()) {
            return
        }
        
        sendButtonNode.textContent = 'Отправка заказа..'
        sendButtonNode.setAttribute('disabled', 'disabled')
        
        OrderClass.send((err, res) => {
            if (err) {
                sendButtonNode.textContent = sendButtonText
                sendButtonNode.removeAttribute('disabled')

                ScrollClass.scrollTo('.happy-order__step_delivery')
            } else if (res) {
                document.location = `/personal/order/make/?order=${ res }`
            }
        }, JSON.stringify(sendData))
    }

    useEffect(() => {
        refetch(() => {
            setLoading(false)
        })
    }, [])
    
    return (isLoading ? <Loading /> : <DataContext.Provider value={ data }>
        <div className="happy-order">
            <div className="happy-order__data">
                <ContactsStep setData={ setData } forceRender={ forceRender } />
                <DeliveryStep setData={ setData } forceRender={ forceRender } />
                <PaymentsStep setData={ setData } forceRender={ forceRender } />
                <Footer setData={ setData } forceRender={ forceRender } handleSendOrder={ handleSendOrder } />
            </div>

            <div className="happy-order__cart">
                <CartSmallApp orderData={ data } />
            </div>
        </div>
    </DataContext.Provider>)
}

const container = document.getElementById('root-order')

if (container) ReactDOM.render(<OrderApp />, container)